import React, { useState, createContext, useContext, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AcoesMenuProvider from './contexts/MenuContext';
import TarefasProvider, { TarefaProvider } from './contexts/TarefaContext';
import Home from './Home';
import HomeUnidades from './unidades/HomeUnidades';
import Login from './Login';
import { useLogin } from './contexts/LoginContext';
import { obterTemaPremium } from './theme';

export const experienciaPremiumAtiva = true;

// Context para alternar o modo de cores do tema
export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export function useColorMode() {
  return useContext(ColorModeContext);
}

function App() {
  const [login] = useLogin();

  // O padrão é tema claro (light)
  const [mode, setMode] = useState<'light' | 'dark'>(() => {
    const savedMode = localStorage.getItem('backup_facil_theme_mode');
    return (savedMode === 'light' || savedMode === 'dark') ? savedMode : 'light';
  });

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const nextMode = prevMode === 'light' ? 'dark' : 'light';
          localStorage.setItem('backup_facil_theme_mode', nextMode);
          return nextMode;
        });
      },
    }),
    []
  );

  const themeLegacy = createTheme({
    palette: {
      primary: {
        main: "#2A51F7",
      },
      secondary: {
        main: "#3d51b5",
      },
    },
  });

  const themePremium = useMemo(() => obterTemaPremium(mode), [mode]);
  const activeTheme = experienciaPremiumAtiva ? themePremium : themeLegacy;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={activeTheme}>
        <TarefasProvider>
          <TarefaProvider>
            <AcoesMenuProvider>
              {login.authenticated ? login?.usuario?.unidade ? <HomeUnidades /> : <Home /> : <Login />}
            </AcoesMenuProvider>
          </TarefaProvider>
        </TarefasProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
